import { capturePolicyApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

const FORBIDDEN_SAVE_MESSAGE = "You don't have permission to change pass-through.";

const isForbiddenError = error => error?.response?.status === HTTP_RESPONSE_STATUS_CODES.FORBIDDEN;

const toSaveErrorMessage = error =>
  isForbiddenError(error) ? FORBIDDEN_SAVE_MESSAGE : extractErrorMessage(error);

export const CAPTURE_POLICY_ACTION_TYPE = createNamedActions('marginCenter/capturePolicy', {
  GET_CAPTURE_ROWS: 'GET_CAPTURE_ROWS',
  SET_CAPTURE_LOADING: 'SET_CAPTURE_LOADING',
  SET_CAPTURE_ERROR: 'SET_CAPTURE_ERROR',
  UPSERT_CAPTURE_ROW: 'UPSERT_CAPTURE_ROW',
  REMOVE_CAPTURE_ROW: 'REMOVE_CAPTURE_ROW',
  SET_CAPTURE_SAVING: 'SET_CAPTURE_SAVING',
  SET_CAPTURE_SAVE_ERROR: 'SET_CAPTURE_SAVE_ERROR',
});

export const getCapturePolicyRowsAction = () => async dispatch => {
  dispatch({ type: CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_LOADING, payload: true });

  try {
    const { data } = await capturePolicyApi.getRows();

    return dispatch({ type: CAPTURE_POLICY_ACTION_TYPE.GET_CAPTURE_ROWS, payload: data });
  } catch (error) {
    return dispatch({
      type: CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_ERROR,
      payload: { isForbidden: isForbiddenError(error) },
    });
  }
};

// Create when no capturePolicyRowId, else update. Returns the saved row on success, null on failure
// (error reduced into save state for inline surfacing).
export const saveCapturePolicyRowAction =
  ({ capturePolicyRowId, request }) =>
  async dispatch => {
    dispatch({ type: CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_SAVING, payload: true });

    try {
      const { data } = capturePolicyRowId
        ? await capturePolicyApi.updateRow(capturePolicyRowId, request)
        : await capturePolicyApi.createRow(request);

      dispatch({ type: CAPTURE_POLICY_ACTION_TYPE.UPSERT_CAPTURE_ROW, payload: data });

      return data;
    } catch (error) {
      dispatch({
        type: CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_SAVE_ERROR,
        payload: toSaveErrorMessage(error),
      });

      return null;
    }
  };

// Returns true on success, null on failure. A failed DELETE reduces the server message into the same
// inline mutation-error slice (surfaced by the Capture banner) and the row is retained.
export const deleteCapturePolicyRowAction = capturePolicyRowId => async dispatch => {
  try {
    await capturePolicyApi.deleteRow(capturePolicyRowId);
  } catch (error) {
    dispatch({
      type: CAPTURE_POLICY_ACTION_TYPE.SET_CAPTURE_SAVE_ERROR,
      payload: toSaveErrorMessage(error),
    });

    return null;
  }

  dispatch({
    type: CAPTURE_POLICY_ACTION_TYPE.REMOVE_CAPTURE_ROW,
    payload: capturePolicyRowId,
  });

  return true;
};
